import { createFileRoute } from "@tanstack/react-router";
import { AppAdvertisingServicePage } from "./services_.app-advertising";

export const Route = createFileRoute("/services_/app-advertising-services")({
  head: () => ({
    meta: [
      {
        title: "App Advertising Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "Mobile App Install & Re-engagement Campaigns.",
      },
    ],
  }),
  component: AppAdvertisingServicePage,
});
